import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { IconButton, Modal, SelectItemType } from "components";
import { useBoundStore } from "store";
import { GetCountryCodesRes } from "api/network";
import classNames from "classnames";
import { createMediaUrl } from "utils";
import { BASE_URL } from "api/constants";

interface props {
  value?: GetCountryCodesRes;
  onChange?: (v: GetCountryCodesRes) => void;
}

export const CountryCodeSelect: FC<props> = (props) => {
  const { countryCodes } = useBoundStore();
  const [open, setOpen] = useState(false);

  const selectItems: SelectItemType[] = useMemo(
    () =>
      countryCodes.map((item) => ({
        imgUrl: BASE_URL + item.IconUTF,
        value: item.ID,
        label: item.Name,
        helperText: item.CountryCode,
      })),
    [countryCodes]
  );

  useEffect(() => {
    if (!props.value && countryCodes.length) {
      props.onChange && props.onChange(countryCodes[0]);
    }
  }, [props.value, countryCodes]);

  const renderItem = useCallback(() => {
    return selectItems.map((code) => (
      <button
        className={classNames("btn btn-block btn-ghost", {
          "bg-primary": props.value?.ID === code.value,
        })}
        key={code.value}
        onClick={() => {
          const selected = countryCodes.find((item) => item.ID === code.value);
          props.onChange && props.onChange(selected!);
          setOpen(false);
        }}
        type="button"
      >
        <div className="flex items-center w-full">
          {!!code.imgUrl && (
            <div className="w-[25px] h-[25px] rounded-md overflow-hidden me-2">
              <img className="w-full h-full" src={code.imgUrl} />
            </div>
          )}
          <div className="flex-1 text-start">{code.label}</div>
          <div dir="ltr">{code.helperText}</div>
        </div>
      </button>
    ));
  }, [selectItems, props.value]);

  return (
    <div>
      <button
        type="button"
        className="btn btn-xs h-[42px] bg-transparent rounded-none shadow-none border-0 border-s border-[#E1E1E1]"
        onClick={() => setOpen(true)}
      >
        <IconButton size="xs" color="solid" iconName="AngleDown" />
        <div dir="ltr">{props.value?.CountryCode}</div>
      </button>

      <Modal
        disableGutters
        open={open}
        onClose={() => setOpen(false)}
        title="انتخاب کد کشور"
      >
        <div className="grid grid-cols-1 gap-2.5 overflow-y-auto max-h-[222px] px-4">
          {renderItem()}
        </div>
      </Modal>
    </div>
  );
};
